import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CropperPageRoutingModule } from './cropper-routing.module';

import { CropperPage } from './cropper.page';
import { ImageCropperModule } from 'ngx-image-cropper';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    CropperPageRoutingModule,
    ImageCropperModule
  ],
  declarations: [CropperPage]
})
export class CropperPageModule {}
